import React from 'react';
import { Form, Button, Space } from 'antd';
import UserForm from '../UserForm/UserForm';
import useMobileFullscreenModalBackHandler from '../../../Hooks/useMobileFullscreenModalBackHandler';
import ResponsiveModal from '../../Shared/ResponsiveModal/ResponsiveModal';
import { useTranslation } from 'react-i18next';

const UserModal = ({
    modalVisible,
    handleCancel,
    handleSubmit,
    editingUser,
    screens,
    setLoading
}) => {
    const [form] = Form.useForm();
    const { t } = useTranslation();
    const [submitDisabled, setSubmitDisabled] = React.useState(!editingUser);
    const [submitLoading, setSubmitLoading] = React.useState(false);

    const onCancel = () => {
        form.resetFields();
        handleCancel();
    };

    const onSubmit = async () => {
        setSubmitLoading(true);
        try {
            await form.submit();
        } finally {
            setSubmitLoading(false);
        }
    };

    const checkFormValues = () => {
        const values = form.getFieldsValue();
        const hasAllValues = !!values.email &&
            !!values.first_name &&
            !!values.last_name && !!(editingUser || values.password);
        setSubmitDisabled(!hasAllValues);
    };

    // Close fullscreen user modal with mobile system back
    useMobileFullscreenModalBackHandler(!!modalVisible && screens?.xs, onCancel);
    return (
        <ResponsiveModal
            key={modalVisible}
            title={editingUser ? t('edit_user') : t('add_user')}
            open={modalVisible}
            onCancel={onCancel}
            destroyOnClose
            desktopWidth={820}
            footer={
                <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
                    <Button onClick={onCancel}>{t('cancel')}</Button>
                    <Button
                        type="primary"
                        onClick={onSubmit}
                        disabled={submitDisabled}
                        loading={submitLoading}
                    >
                        {editingUser ? t('update_user') : t('create_user')}
                    </Button>
                </Space>
            }
        >
            <UserForm
                form={form}
                onFinish={handleSubmit}
                initialValues={editingUser}
                screens={screens}
                setLoading={setLoading}
                onValuesChange={checkFormValues}
            />
        </ResponsiveModal>
    );
};

export default UserModal;
